<template>
  <div v-if="!states.isMobile" :style="{top: `${pc}%`}" class="anchor w-100 visually-hidden position-absolute" :id="id"></div>
  <div v-if="states.isMobile" :style="{top: `${mb}%`}" class="anchor w-100 visually-hidden position-absolute" :id="id"></div>
</template>

<script>
export default {
  name: "ResponsiveAnchor",
  inject: ['states'],
  props: ['mb', 'pc', 'id']
}
</script>

<style scoped lang="scss">
.anchor {
  height: 1px;
  left: 0;
}
</style>